import { render, staticRenderFns } from "./MediaView.vue?vue&type=template&id=600b614d&"
import script from "./MediaView.vue?vue&type=script&lang=js&"
export * from "./MediaView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QBtn,QInput,QIcon} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QBtn,QInput,QIcon})
